import { ca } from '@cian/analytics';
import { EValuationTabs } from './constants/tabs';
import { EValue as EPeriod } from '../../repositories/newbuilding-estimate/entities/filters/PeriodFilter';
import { EValue as EType } from '../../repositories/newbuilding-estimate/entities/filters/PriceTypeFilter';
import { EValue as ERooms } from '../../repositories/newbuilding-estimate/entities/filters/RoomCountFilter';

const mapFilterValueToAnalytics = {
  [ERooms.Studio]: '0',
  [ERooms.OneRoom]: '1',
  [ERooms.TwoRoom]: '2',
  [ERooms.ThreeRoom]: '3',
  [ERooms.FourRoom]: '4',

  [EPeriod.HalfYear]: 'halfYear',
  [EPeriod.Year]: 'year',
  [EPeriod.AllTime]: 'allTime',

  [EType.PriceSqm]: 'price_sqm',
  [EType.Price]: 'price',
};

const mapFilterNameToAnalytics = {
  roomCount: 'PriceHistory',
  period: 'Period',
  pricesType: 'PriceType',
};

const mapTabsToAnalytics: Record<EValuationTabs, string> = {
  [EValuationTabs.PriceDynamic]: 'prices',
  [EValuationTabs.SalesDynamic]: 'sales',
};

export function trackRealtyValuationInView() {
  ca('teaser', {
    product: {
      name: 'prices_and_sales_show',
    },
  });
}

export function trackRealtyValuationFilterChange(
  filterName: keyof typeof mapFilterNameToAnalytics,
  filterValue: keyof typeof mapFilterValueToAnalytics,
) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Select_sopr',
    label: `${mapFilterNameToAnalytics[filterName]}/${mapFilterValueToAnalytics[filterValue]}`,
    useLastProducts: true,
  });
}

export function trackRealtyValuationTabsChange(tab: EValuationTabs) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Select_sopr',
    label: `Tab/${mapTabsToAnalytics[tab]}`,
    useLastProducts: true,
  });
}

export function trackRealtyValuationChartTooltipShow(tab: EValuationTabs) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Show_sopr',
    label: `Tooltip/${mapTabsToAnalytics[tab]}`,
    useLastProducts: true,
  });
}
